import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {setCookie} from "../../utils/cookie";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const verifyCodeApi = createAsyncThunk(
    'users/verify',
    async (account: any, { rejectWithValue }) => {

        const resendURL = `${URL_API}/supplier-portal/verify/${account.id}`;

        try {
            const { data } = await axios.post<ResetResult>(resendURL, account, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            if(data){
                // get the current date
                const d = new Date();

                // get the current time in milliseconds format
                const currentTime = d.getTime();
                setCookie('lastActive', currentTime);
            }

            return data;
        } catch (error) {
            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);